import { forwardRef } from 'react';
import MuiCard, { type CardProps as MuiCardProps } from '@mui/material/Card';

export type CardProps = MuiCardProps;

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ elevation = 1, ...rest }, ref) => <MuiCard ref={ref} elevation={elevation} {...rest} />
);

Card.displayName = 'Card';
